export const repairPriorityDropdown = [
    { value: "high", label: "High" },
    { value: "medium", label: "Medium" },
    { value: "low", label: "Low" }
];

export const maintenanceTypesDropdown = [
    { value: "scheduled", label: "Scheduled" },
    { value: "unscheduled", label: "Unscheduled" }
];

export const priorityOptions = [
    { value: "low", label: "Low" },
    { value: "medium", label: "Medium" },
    { value: "high", label: "High" }
];

export const repairPriorityOptions = [
    { value: "scheduled", label: "Scheduled" },
    { value: "Unscheduled", label: "Unscheduled" },
];

export const statusOptions = [
    { value: "open", label: "Open" },
    { value: "in_progress", label: "In Progress" },
    { value: "resolved", label: "Resolved" },
    { value: "completed", label: "Completed" },
    { value: "closed", label: "Closed" }
];

export const workOrderStatusFilterOptions = [
    { value: "pending", label: "Pending" },
    { value: "in_progress", label: "In Progress" },
    { value: "approved", label: "Approved" },
    { value: "completed", label: "Completed" },
    { value: "closed", label: "Closed" },
];

export const approvalStatusOptions = [
    { value: "approved", label: "Approved" },
    { value: "in_progress", label: "In Progress" },
    { value: "completed", label: "Completed" },
]

export const serviceStatusOptions = [
    { value: "pending", label: "Pending" },
    { value: "in_progress", label: "In Progress" },
    { value: "completed", label: "Completed" },
]

export const workOrderStatusOptions = [
    { value: "open", label: "Open" },
    { value: "pending", label: "Pending" },
    { value: "completed", label: "Completed" },
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
    { value: "closed", label: "Closed" },
];

export const uploadTypeOptions = [
    { value: 'maintenance', label: 'Maintenance' },
    { value: 'tyres', label: 'Tyres' },
];

export const workStatusOptions = [
    { value: "created", label: "Created" },
    { value: "open", label: "Open" },
    { value: "pending", label: "Pending" },
    { value: "completed", label: "Completed" }
];

export const filterDropdown = [
    {value: "pending", label: "Pending"},
    {value: "approved", label: "Approved"},
    {value: "rejected", label: "Rejected"},
]

export const categoryStatusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" }
];

export const categoryTypeOptions = [
    { value: "part", label: "Part" },
    { value: "general", label: "General" }
];

export const vehicleTypeStatusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" }
];

export const vehicleClassOptions = [
    { value: "commercial", label: "Commercial" },
    { value: "pool", label: "Pool" },
    { value: "attached", label: "Attached" }
];

export const partModelStatusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" }
];

export const paymentTermsOptions = [
  { label: "Net 7", value: "7" },
  { label: "Net 14", value: "14" },
  { label: "Net 30", value: "30" },
  { label: "Net 45", value: "45" },
  { label: "Net 60", value: "60" },
];


